import { render, staticRenderFns } from "./AgentsRemark.vue?vue&type=template&id=7241456d&scoped=true"
import script from "./AgentsRemark.vue?vue&type=script&lang=js"
export * from "./AgentsRemark.vue?vue&type=script&lang=js"
import style0 from "./AgentsRemark.vue?vue&type=style&index=0&id=7241456d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241456d",
  null
  
)

export default component.exports